import {Col, Row} from "react-bootstrap";
import React, {memo, useEffect, useState} from "react";
import moment from "moment";

function StundenKostenschaetzung(props) {

    const [materialCost, setMaterialCost] = useState(props.kosten?.material)
    const [vorhaltungCost, setVorhaltungCost] = useState(props.kosten?.vorhaltung)
    const [nebenCost, setNebenCost] = useState(props.kosten?.neben)
    const [fahrtCost, setFahrtCost] = useState(props.kosten?.fahrt)
    const [ustdCost, setUstdCost] = useState(props.kosten?.ueberstunden)
    const [frist, setFrist] = useState(props.kosten?.frist)

    useEffect(() => {
        setMaterialCost(props.kosten?.material)
        setVorhaltungCost(props.kosten?.vorhaltung)
        setNebenCost(props.kosten?.neben)
        setFahrtCost(props.kosten?.fahrt)
        setUstdCost(props.kosten?.ueberstunden)
        setFrist(moment(props.kosten?.frist).format("YYYY-MM-DD"))
    }, [props.originState, props.kosten?.material, props.kosten?.neben, props.kosten?.fahrt, props.kosten?.ueberstunden, props.kosten?.frist]);

    function updateField(key, value) {


        props.setIsChange(false)

        if (key === "material") {


            setMaterialCost(value)
            props.setStundenReportData({
                ...props.stundenReportData, cost_estimation: {
                    ...props.stundenReportData.cost_estimation, material: value
                }
            })
        } else if (key === "vorhaltung") {
            setVorhaltungCost(value)
            props.setStundenReportData({
                ...props.stundenReportData, cost_estimation: {
                    ...props.stundenReportData.cost_estimation, vorhaltung: value
                }
            })
        } else if (key === "neben") {
            setNebenCost(value)
            props.setStundenReportData({
                ...props.stundenReportData, cost_estimation: {
                    ...props.stundenReportData.cost_estimation, neben: value
                }
            })
        } else if (key === "fahrt") {
            setFahrtCost(value)
            props.setStundenReportData({
                ...props.stundenReportData, cost_estimation: {
                    ...props.stundenReportData.cost_estimation, fahrt: value
                }
            })
        } else if (key === "ueberstunden") {
            setUstdCost(value)
            props.setStundenReportData({
                ...props.stundenReportData, cost_estimation: {
                    ...props.stundenReportData.cost_estimation, ueberstunden: value
                }
            })
        } else if (key === "frist") {
            setFrist(value)
            props.setStundenReportData({
                ...props.stundenReportData, cost_estimation: {
                    ...props.stundenReportData.cost_estimation, frist: value
                }
            })
        }
    }


    return (<>
        <div>
            <Row>

                <Col sm={12}>
                    <label className="handwai-text-label-main">
                        {"Kostenschätzung"}
                    </label>
                </Col>
            </Row>
            <br/>

            <Row>


                {/*<Col md={10} style={{paddingLeft:0,textAlign:"left"}}>

                <label className="handwai-text-label-main">
                        {"Kostenschätzung"}
                    </label>
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp; &nbsp;
                    <label className="handwai-text-label-normal"> Material </label>
                   &nbsp; <input type="text"
                           disabled={props.originState}
                           value={materialCost}
                           onChange={(e) => updateField("material", e.target.value)}/> &nbsp; &nbsp;&nbsp;

                    <label className="handwai-text-label-normal"> Vorhaltung</label>
                    &nbsp;<input type="text"
                           disabled={props.originState}
                           value={vorhaltungCost}
                           onChange={(e) => updateField("vorhaltung", e.target.value)}/> &nbsp; &nbsp;&nbsp;

                    <label className="handwai-text-label-normal"> Neben </label>
                    &nbsp;<input type="text"
                           disabled={props.originState}
                           value={nebenCost}
                           onChange={(e) => updateField("neben", e.target.value)}/> &nbsp; &nbsp;&nbsp;
                    <label className="handwai-text-label-normal"> Fahrt </label>
                    &nbsp;<input type="text"
                           disabled={props.originState}
                           value={fahrtCost}
                           onChange={(e) => updateField("fahrt", e.target.value)}/> &nbsp; &nbsp;&nbsp;
                    <label className="handwai-text-label-normal"> Ü.std </label>
                    &nbsp;<input type="text"
                           disabled={props.originState}
                           value={ustdCost}
                           onChange={(e) => updateField("ueberstunden", e.target.value)}/> &nbsp; &nbsp;&nbsp;
                    <label className="handwai-text-label-normal"> Frist </label>
                    &nbsp;<input type="date"
                           disabled={props.originState}
                           value={frist}
                           onChange={(e) => updateField("frist", e.target.value)}/> &nbsp; &nbsp;&nbsp;
                </Col>*/}


                <Col sm={11}>
                    <Row>

                        <Col sm={1} style={{marginRight:-90}}>
                            <label style={{width: "50%", whiteSpace: "nowrap"}}
                                   className="handwai-text-label-normal"> Material </label>
                        </Col>
                        <Col sm={1} >

                            <input type="text"
                                   style={{
                                       width: "90%", boxSizing: "border-box"
                                   }}
                                   disabled={props.originState||props.disableStatus}
                                   value={materialCost}
                                   onChange={(e) => updateField("material", e.target.value)}/>

                            <label style={{width: "10%", whiteSpace: "nowrap", fontSize: 23}}
                                   className="handwai-text-label-normal">€</label>

                        </Col>


                        <Col sm={1} style={{marginLeft:105,marginRight:-70}}>
                            <label style={{width: "50%", whiteSpace: "nowrap"}}
                                   className="handwai-text-label-normal"> Vorhaltung</label>
                        </Col>
                        <Col sm={1}>
                            <input type="text"
                                   style={{
                                       width: "90%", boxSizing: "border-box"
                                   }}
                                   disabled={props.originState||props.disableStatus}
                                   value={vorhaltungCost}
                                   onChange={(e) => updateField("vorhaltung", e.target.value)}/>
                            <label style={{width: "10%", whiteSpace: "nowrap", fontSize: 23}}
                                   className="handwai-text-label-normal">€</label>

                        </Col>


                        <Col sm={1} style={{marginLeft:105,marginRight:-100}}>
                            <label style={{width: "50%", whiteSpace: "nowrap"}}
                                   className="handwai-text-label-normal"> Neben </label>
                        </Col>
                        <Col sm={1}>
                            <input type="text"
                                   style={{
                                       width: "90%", boxSizing: "border-box"
                                   }}
                                   disabled={props.originState||props.disableStatus}
                                   value={nebenCost}
                                   onChange={(e) => updateField("neben", e.target.value)}/>
                            <label style={{width: "10%", whiteSpace: "nowrap", fontSize: 23}}
                                   className="handwai-text-label-normal">€</label>
                        </Col>


                        <Col sm={1} style={{marginLeft:105,marginRight:-100}}>
                            <label style={{width: "50%", whiteSpace: "nowrap"}}
                                   className="handwai-text-label-normal"> Fahrt </label>
                        </Col>
                        <Col sm={1} >
                            <input type="text"
                                   style={{
                                       width: "90%", boxSizing: "border-box"
                                   }}
                                   disabled={props.originState||props.disableStatus}
                                   value={fahrtCost}
                                   onChange={(e) => updateField("fahrt", e.target.value)}/>
                            <label style={{width: "10%", whiteSpace: "nowrap", fontSize: 23}}
                                   className="handwai-text-label-normal">€</label>
                        </Col>

                        <Col sm={1} style={{marginLeft:105,marginRight:-100}}>
                            <label style={{width: "50%", whiteSpace: "nowrap"}}
                                   className="handwai-text-label-normal"> Ü.std </label>
                        </Col>
                        <Col sm={1}>
                            <input type="text"
                                   style={{
                                       width: "90%", boxSizing: "border-box"
                                   }}
                                   disabled={props.originState||props.disableStatus}
                                   value={ustdCost}
                                   onChange={(e) => updateField("ueberstunden", e.target.value)}
                            />
                            <label style={{width: "10%", whiteSpace: "nowrap", fontSize: 23}}
                                   className="handwai-text-label-normal">%</label>
                        </Col>

                        <Col sm={1} style={{marginLeft:105,marginRight:-100}}>
                            <label
                                style={{width: "50%", whiteSpace: "nowrap"}}
                                className="handwai-text-label-normal"> Frist </label>
                        </Col>
                        <Col sm={1} >
                            <input type="date"
                                   disabled={props.originState||props.disableStatus}
                                   defaultValue={null}

                                   value={frist}
                                   onChange={(e) => updateField("frist", e.target.value)}/>
                        </Col>
                    </Row>
                </Col>


            </Row>
        </div>
    </>)
}

export default memo(StundenKostenschaetzung)


/*
import {Col, Row} from "react-bootstrap";
import React, {memo, useEffect, useState} from "react";
import moment from "moment";

function StundenKostenschaetzung(props) {

    const [materialCost, setMaterialCost] = useState(props.kosten?.material)
    const [vorhaltungCost, setVorhaltungCost] = useState(props.kosten?.vorhaltung)
    const [nebenCost, setNebenCost] = useState(props.kosten?.neben)
    const [fahrtCost, setFahrtCost] = useState(props.kosten?.fahrt)
    const [ustdCost, setUstdCost] = useState(props.kosten?.ueberstunden)
    const [frist, setFrist] = useState(props.kosten?.frist)

    useEffect(() => {
        setMaterialCost(props.kosten?.material)
        setVorhaltungCost(props.kosten?.vorhaltung)
        setNebenCost(props.kosten?.neben)
        setFahrtCost(props.kosten?.fahrt)
        setUstdCost(props.kosten?.ueberstunden)
        setFrist(moment(props.kosten?.frist).format("YYYY-MM-DD"))
    }, [props.originState, props.kosten?.material, props.kosten?.neben, props.kosten?.fahrt, props.kosten?.ueberstunden, props.kosten?.frist]);

    function updateField(key, value) {

        props.setIsChange(false)

        if (key === "material") {
            setMaterialCost(value)
            props.setStundenReportData({
                ...props.stundenReportData, cost_estimation: {
                    ...props.stundenReportData.cost_estimation, material: value
                }
            })
        } else if (key === "vorhaltung") {
            setVorhaltungCost(value)
            props.setStundenReportData({
                ...props.stundenReportData, cost_estimation: {
                    ...props.stundenReportData.cost_estimation, vorhaltung: value
                }
            })
        } else if (key === "neben") {
            setNebenCost(value)
            props.setStundenReportData({
                ...props.stundenReportData, cost_estimation: {
                    ...props.stundenReportData.cost_estimation, neben: value
                }
            })
        } else if (key === "fahrt") {
            setFahrtCost(value)
            props.setStundenReportData({
                ...props.stundenReportData, cost_estimation: {
                    ...props.stundenReportData.cost_estimation, fahrt: value
                }
            })
        } else if (key === "ueberstunden") {
            setUstdCost(value)
            props.setStundenReportData({
                ...props.stundenReportData, cost_estimation: {
                    ...props.stundenReportData.cost_estimation, ueberstunden: value
                }
            })
        } else if (key === "frist") {
            setFrist(value)
            props.setStundenReportData({
                ...props.stundenReportData, cost_estimation: {
                    ...props.stundenReportData.cost_estimation, frist: value
                }
            })
        }
    }


    return (<>
        <div
            style={{
                marginLeft: -15
            }}
        >
            <Row>
                <Col/>
                <Col/>
                <Col/>
                <Col>
                    <label className="handwai-text-label-main">
                        {"Kostenschätzung"}
                    </label>
                </Col>
                <Col sm={10}/>
            </Row>
        </div>
        <br/>
        <div
            style={{
                marginLeft: -13
            }}
        >
            <Row>

                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp; &nbsp;
                <Col>

                    <label className="handwai-text-label-normal"> Material </label>
                    <input type="text"
                           disabled={props.originState}
                           value={materialCost}
                           onChange={(e) => updateField("material", e.target.value)}/> &nbsp; &nbsp;&nbsp;

                    <label className="handwai-text-label-normal"> Vorhaltung</label>
                    <input type="text"
                           disabled={props.originState}
                           value={vorhaltungCost}
                           onChange={(e) => updateField("vorhaltung", e.target.value)}/> &nbsp; &nbsp;&nbsp;

                    <label className="handwai-text-label-normal"> Neben </label>
                    <input type="text"
                           disabled={props.originState}
                           value={nebenCost}
                           onChange={(e) => updateField("neben", e.target.value)}/> &nbsp; &nbsp;&nbsp;
                    <label className="handwai-text-label-normal"> Fahrt </label>
                    <input type="text"
                           disabled={props.originState}
                           value={fahrtCost}
                           onChange={(e) => updateField("fahrt", e.target.value)}/> &nbsp; &nbsp;&nbsp;
                    <label className="handwai-text-label-normal"> Ü.std </label>
                    <input type="text"
                           disabled={props.originState}
                           value={ustdCost}
                           onChange={(e) => updateField("ueberstunden", e.target.value)}/> &nbsp; &nbsp;&nbsp;
                    <label className="handwai-text-label-normal"> Frist </label>
                    <input type="date"
                           disabled={props.originState}
                           value={frist}
                           onChange={(e) => updateField("frist", e.target.value)}/> &nbsp; &nbsp;&nbsp;
                </Col>


            </Row>
        </div>
    </>)
}

export default memo(StundenKostenschaetzung)*/
